<template>
  <div>
    <el-drawer :destroy-on-close="true" :append-to-body="true" title="Ayarlar" :visible.sync="settings"
      :with-header="false">
      <div class="row" style="padding: 50px">
        <div class="col-md-12">
          <label class="dark-inverted" for="">{{ $t("module.speed") }}</label>
          <el-slider v-model="speed" :step="1" :min="1" :max="speeds.length" show-stops></el-slider>
        </div>
        <div class="col-md-12">
          <label class="dark-inverted" for="">{{ $t("module.mode") }}</label>
          <el-slider v-model="mode" :step="1" :min="1" :max="4" show-stops></el-slider>
        </div>
        <div class="col-md-12 mb-3">
          <label class="dark-inverted d-block" for="">{{
            $t("module.autolevel")
            }}</label>
          <el-switch style="margin-top: 8px" v-model="autoLevel" :active-text="$t('module.yes')" :active-value="1"
            :inactive-value="0" :inactive-text="$t('module.no')">
          </el-switch>
        </div>
      </div>
    </el-drawer>
    <div id="goz_esnetme" @click="
        pause = true;
        $root.$emit('pause', true);
      ">
      <paused v-if="pause" @click="
          $root.$emit('pause', !pause);
          pause = false;
        "></paused>
      <a href="javascript:;" @click.stop="
          $root.$emit('pause', !pause);
          pause = !pause;
        " class="pause">
        <i :class="pause == true ? 'el-icon-video-play' : 'el-icon-video-pause'"></i>
      </a>
      <a href="javascript:;" v-if="config == null || config == undefined" @click.stop="settings = true" class="settings">
        <i class="el-icon-setting"></i>
      </a>
      <div style="
          width: 15px;
          height: 15px;
          position: absolute;
          background-color: white;
          border-radius: 50%;
        "></div>
      <div v-for="i in maxShape" :key="i + shapes[i - 1]" style="border: 4px solid #fff; position: absolute" :style="{
          width:
            ((currentShape == 'rotate' && mode != 4
              ? wrapper.height * 0.7
              : wrapper.width) /
              (maxShape + 1)) *
              (i + 1) -
            20 +
            'px',
          height:
            ((currentShape == 'rotate' && mode != 4
              ? wrapper.height * 0.7
              : wrapper.height) /
              (maxShape + 1)) *
              (i + 1) -
            20 +
            'px',
          transform:
            'rotate(' +
            (currentShape == 'rotate' && mode != 4 ? '45deg' : '0deg') +
            ')',
          borderRadius: currentShape == 'circle' && mode != 4 ? '50%' : '0',
          display: shapes[i - 1],
          borderWidth: mode != 4 ? '3px' : '0px',
        }">
        <div style="
            position: absolute;
            left: 0px;
            top: 0px;
            color: white;
            font-size: 20px;
            font-weight: bold;
          " v-if="mode == 4">
          {{ word }}
        </div>
        <div style="
            position: absolute;
            left: 0px;
            bottom: 0px;
            color: white;
            font-size: 20px;
            font-weight: bold;
          " v-if="mode == 4">
          {{ word }}
        </div>
        <div style="
            position: absolute;
            right: 0px;
            top: 0px;
            color: white;
            font-size: 20px;
            font-weight: bold;
          " v-if="mode == 4">
          {{ word }}
        </div>
        <div style="
            position: absolute;
            right: 0px;
            bottom: 0px;
            color: white;
            font-size: 20px;
            font-weight: bold;
          " v-if="mode == 4">
          {{ word }}
        </div>

        <div v-if="currentShape != 'circle' && mode != 4 && 1 == 2" style="
            width: 10px;
            height: 10px;
            background-color: white;
            position: absolute;
            left: -5px;
            top: -5px;
            border-radius: 50%;
          "></div>
        <div v-if="currentShape != 'circle' && mode != 4 && 1 == 2" style="
            width: 10px;
            height: 10px;
            background-color: white;
            position: absolute;
            bottom: -5px;
            left: -5px;
            border-radius: 50%;
          "></div>
        <div v-if="currentShape != 'circle' && mode != 4 && 1 == 2" style="
            width: 10px;
            height: 10px;
            background-color: white;
            position: absolute;
            right: -5px;
            top: -5px;
            border-radius: 50%;
          "></div>
        <div v-if="currentShape != 'circle' && mode != 4 && 1 == 2" style="
            width: 10px;
            height: 10px;
            background-color: white;
            position: absolute;
            right: -5px;
            bottom: -5px;
            border-radius: 50%;
          "></div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
export default {
  name: "EsnekGormeAlani",
  props: ["config"],
  data() {
    return {
      pause: false,
      speed: 1,
      speeds: [500, 461, 428, 400, 375, 352, 333],
      mode: 1,
      interval: null,
      maxShape: 14,
      currentShape: "square",
      wrapper: {
        width: 0,
        height: 0,
      },
      step: 0,
      maxStepCount: 14,
      shapes: [],
      word: this.$i18n.locale == 'tr' ? "Merhaba" : "Salam",
      settings: false,
      autoLevel: 0,
      tourCount: 0,
    };
  },
  created() {
    for (let index = 0; index < this.maxShape; index++) {
      this.shapes.push("none");
    }

    if (this.config != undefined && this.config != null) {
      if (this.config.mode != null && this.config.mode != "")
        this.mode = this.config.mode;
      if (this.config.mode != null && this.config.mode != "")
        this.speed = this.config.speed;
      this.autoLevel = this.config.auto_level;
    }
  },
  mounted() {
    this.wrapper = {
      width: document.getElementById("goz_esnetme").clientWidth,
      height: document.getElementById("goz_esnetme").clientHeight,
    };

    this.start();
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  methods: {
    start() {
      this.interval = setInterval(() => {
        if (this.pause) return;
        this.$store.state.ticks[this.$store.state.selectedTick2].play();
        if (this.step == this.maxStepCount) {
          this.step = 0;
          this.calculateDisplays();
          if (this.currentShape == "square") {
            this.currentShape = "rotate";
            return;
          }
          if (this.currentShape == "rotate") {
            this.currentShape = "circle";
            return;
          }
          if (this.currentShape == "circle") {
            this.currentShape = "square";
            this.tourCount += 1;
            return;
          }
        }
        this.step += 1;
        this.calculateDisplays();
      }, this.currentSpeed);
    },
    calculateDisplays() {
      if (this.mode == 1) {
        if (this.step == 0) {
          this.shapes = this.shapes.map((k) => "none");
          return;
        }
        this.$set(this.shapes, this.step - 1, "block");
      }
      if (this.mode == 2) {
        this.shapes = this.shapes.map((k) => "none");
        this.$set(this.shapes, this.step - 1, "block");
      }
      if (this.mode == 3 || this.mode == 4) {
        if (this.step > this.maxStepCount / 2) {
          this.$set(this.shapes, this.step - this.maxStepCount / 2 - 1, "none");
        } else {
          this.$set(this.shapes, this.step - 1, "block");
        }
      }
    },
  },
  computed: {
    currentSpeed() {
      return this.speeds[this.speed - 1];
    },
  },
  watch: {
    currentSpeed: function () {
      clearInterval(this.interval);
      this.start();
    },
    mode: function () {
      if (this.mode == 3) {
        this.maxStepCount = 28;
        this.maxShape = 14;
      } else if (this.mode == 4) {
        this.maxStepCount = 10;
        this.maxShape = 5;
      } else if (this.mode == 1) {
        this.maxStepCount = 14;
        this.maxShape = 14;
      } else {
        this.maxStepCount = 14;
        this.maxShape = 14;
      }
      this.step = 0;
      clearInterval(this.interval);
      this.start();
    },
    step: function () {
      if (this.autoLevel == 0) return;
      if (this.step == this.maxStepCount) {
        this.speed = Math.min(
          this.speed + 1,
          this.config && this.config.max_speed
            ? this.config.max_speed
            : this.speeds.length
        );
      }
    },
    tourCount: function () {
      if (this.autoLevel == 0) return;
      if (this.tourCount % 2 == 0) {
        this.mode = Math.min(
          this.mode + 1,
          this.config && this.config.max_mode ? this.config.max_mode : 4
        );
      }
    },
  },
};
</script>

<style lang="less" scoped>
#goz_esnetme {
  width: 700px;
  height: 500px;
  background: black;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  margin: 0 auto;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/modules/EsnekGormeAlani.vue